export enum MimeTypes {
    JSON = "application/json",
    OCTET_STREAM = "application/octet-stream",
    PDF = "application/pdf"
}